import { render, staticRenderFns } from "./TabSteps.vue?vue&type=template&id=3fbefee3&"
import script from "./TabSteps.vue?vue&type=script&lang=js&"
export * from "./TabSteps.vue?vue&type=script&lang=js&"
import style0 from "./TabSteps.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports